module.exports = __webpack_public_path__ + "img/md_flow01-s.ee58fd0a.png";